import {ExclamationCircleOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import {TooltipProps} from 'antd/es/tooltip';
import cn from 'classnames';
import React from 'react';

import {TJSXContent} from 'shared/types';

import './with-tooltip-error.less';

interface IWithTooltipErrorProps {
    errors: TooltipProps['title'] | undefined;
    visible: boolean;
    children: TJSXContent;
    className?: cn.Argument;
    withExclamation?: boolean;
}

export const WithTooltipError = ({
    errors, visible, children, className, withExclamation,
}: IWithTooltipErrorProps) => (
    <Tooltip
        overlayClassName={cn('with-tooltip-error', className)}
        title={
            withExclamation ? (
                <>
                    <ExclamationCircleOutlined />
                    {errors}
                </>
            ) : errors
        }
        visible={visible}
        placement="right"
    >
        {children}
    </Tooltip>
);
